var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 2L9.16 0.8C9.07 0.34 8.66 0 8.18 0H1C0.45 0 0 0.45 0 1V16C0 16.55 0.45 17 1 17C1.55 17 2 16.55 2 16V10H7.6L7.84 11.2C7.93 11.67 8.34 12 8.82 12H14C14.55 12 15 11.55 15 11V3C15 2.45 14.55 2 14 2H9.4Z",
    fill: "#F04438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red-flag.dc4ab0750a7952fd5a5e77c12b8038d4.svg";
export { ForwardRef as ReactComponent };